export const blockIconsCommunicationPhoneEnabledNew = (
	<span className='material-symbols-outlined'>phone_enabled</span>
);
